export const LANG_CONST = 'lang';

export const TABS = Object.freeze({
  QUEUE: 1,
  POSTPONED: 2,
  PREENTRY: 3,
  CANCELED: 4,
  SEARCH: 5,
  READIED: 6,
});

export const TICKET_STATUS = Object.freeze({
  CLOSED: 'closed',
  WAITING: 'waiting',
  POSTPONED: 'postponed',
  CANCELED: 'canceled',
  REDIRECTED: 'redirected',
  READIED: 'ready'
});

export const TAG_TYPE = Object.freeze({
  OPERATOR: 'operator',
  TICKET: 'ticket'
});

export const USER_STATUSES = Object.freeze({
  IDLE: 1,
  WORKING: 2,
  DOCUMENT_PROCESSING: 3,
  BREAK: 4
});

export const USER_STATUSES_VISIBLE = [
  {
    id: USER_STATUSES.DOCUMENT_PROCESSING,
    title: 'd_ws_status_tag_documents',
    icon: 'ri-file-list-3-line',
    default: true
  },
  {
    id: USER_STATUSES.BREAK,
    title: 'd_ws_status_tag_break',
    icon: 'ri-cup-line',
    default: true
  }
];

export const MODAL = Object.freeze({
  ADD_TAGS: 'addTags',
  ALIVE: 'aliveModal',
  CHANGE_LANGUAGE: 'changeLanguage',
  CHANGE_STATUS: 'changeStatus',
  PREENTRY: 'preEntry',
  STATS: 'operatorStats',
  USER_PROFILE: 'userProfileModal',
  REDIRECT: 'redirect',
  CALL_TICKET_MOBILE: 'callTicketMobile',
  EDIT_ROUTE: 'editRoute'
});


export const MODAL_TYPE_MOBILE = Object.freeze({
  FULL: 'full',
  BUBBLE: 'bubble',
  BUBBLE_FLAT: 'bubble-flat'
});

export const CONTEXT_MENU_ACTIONS = Object.freeze({
  CALL: 'call',
  BACK_TO_ALIVE: 'back_to_alive',
  ISSUED: 'issued',
});

export const ERROR_CODE = Object.freeze({
  BAD_REQUEST: 4,
  WRONG_CREDENTIALS: 5,
  NOT_HAVE_PERMISSIONS: 7,
  UNAUTHORIZED: 9,
  TOKEN_EXPIRED: 29,
  DEVICE_DISABLED: 31,
  NOT_ASSOCIATED_DEVICE: 32,
  WINDOW_IS_BUSY: 33,
  DEVICE_NOT_FOUND: 34,
  WITHOUT_WINDOW: 35,
  NO_ACCESS_TO_WINDOW: 7
});

export const USER_ROLE = Object.freeze({
  SUPERADMIN: 0,
  COMPANY_ADMIN: 1,
  UNIT_ADMIN: 2,
  OFFICE_ADMIN: 3,
  OPERATOR: 4,
  SENIOR_OPERATOR: 5
});

export const REDIRECT_MODE = Object.freeze({
  REDIRECT: 'redirect',
  BACK_TO_ALIVE: 'back_to_alive'
});
